const $header = $('.header');
const $burger = $header.find('.header__burger');
const $dropdown = $header.find('.header__dropdown');

$burger.off('click').on('click', (e) => {
	$(e.currentTarget).toggleClass('is-open');
	$dropdown.toggleClass('is-open');
	$('html, body').toggleClass('no-scroll');
});
